export enum Role {
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
  READ_ONLY = 'READ_ONLY',
}

const AVAILABLE_ROLES = Object.keys(Role);

class MembershipRole {
  public readonly id: string;
  public readonly role: Role;
  constructor({ id, role }: { id: string; role: Role }) {
    this.id = id;
    this.role = role;
  }

  public static fromJSON = (value: any) => {
    const { id, role } = Object.assign({}, value);

    if (typeof id !== 'string') throw new TypeError('.id must be a string');
    if (!AVAILABLE_ROLES.includes(role)) throw new TypeError('.role must be a valid Role string');

    return new MembershipRole({
      id,
      role,
    });
  };
}

export default MembershipRole;
